import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function ENIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 16, 16);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path fill="#0059ff" d="M2.128 11.636V4.364h4.39v.78h-3.51v2.458H6.29v.782H3.009v2.471h3.565v.781z" /><path fill="#171717" d="M2.128 11.636V4.364h4.39v.78h-3.51v2.458H6.29v.782H3.009v2.471h3.565v.781z" /><path fill="#0059ff" d="M13.872 4.364v7.272h-.853l-3.963-5.71h-.07v5.71h-.882V4.364h.853l3.977 5.724h.071V4.364z" /><path fill="#171717" d="M13.872 4.364v7.272h-.853l-3.963-5.71h-.07v5.71h-.882V4.364h.853l3.977 5.724h.071V4.364z" /></svg>
  );
}

export default ENIcon;
